export default __webpack_public_path__ + "static/media/icon-forget-phone.4e8f3350.webp";